export default "__VITE_ASSET__CyvEhCz3__"